"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebsocketClientConnectorRpcLocal = void 0;
const identifiers_1 = require("../../identifiers");
class WebsocketClientConnectorRpcLocal {
    options;
    constructor(options) {
        this.options = options;
    }
    async requestConnection(_request, context) {
        if (this.options.abortSignal.aborted) {
            return {};
        }
        const senderPeerDescriptor = context.incomingSourceDescriptor;
        if (!this.options.hasConnection((0, identifiers_1.toNodeId)(senderPeerDescriptor))) {
            const connection = this.options.connect(senderPeerDescriptor);
            this.options.onNewConnection(connection);
        }
        return {};
    }
}
exports.WebsocketClientConnectorRpcLocal = WebsocketClientConnectorRpcLocal;
//# sourceMappingURL=WebsocketClientConnectorRpcLocal.js.map